import { filterOptions } from '@/utils/query-base'

// const be = filterOptions(['EQ'])
const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export const pageSearch = {
  'saleCenter': {
    title: '营销单元',
    type: 'select',
    equation: all,
    dictionary: 'sale'
  },
}

export default {
  'saleCenterName': {
    title: '营销大区名称',
    slot: true,
  },
  'brand': {
    describe: true,
    suffix: 'Name',
    title: '存货分类',
    type: 'select',
    equation: city,
    dictionary: 'A0019',
    width: 200
  },
  'totalClients': {
    title: '客户总数量(家)',
    xlsxFmt: {
      t: 'n'
    }
  },
  'totalPlanQty': {
    title: '2023年签约总量(件)',
    xlsxFmt: {
      t: 'n'
    }
  },
  'totalPlanMoney': {
    title: '2023年签约总金额(万元)',
    xlsxFmt: {
      t: 'n'
    }
  },
  'totalAdviseClients': {
    title: '建议签约商家总总量(家)',
    xlsxFmt: {
      t: 'n'
    }
  },
  'totalAdviseQty': {
    title: '建议签约总量(件)',
    xlsxFmt: {
      t: 'n'
    }
  },
  'totalAdviseMoney': {
    title: '建议签约总金额(万元)',
    xlsxFmt: {
      t: 'n'
    }
  },
  'signedClients': {
    title: '已签约客户数量(家)',
    xlsxFmt: {
      t: 'n'
    }
  },
  'signedQty': {
    title: '已签约总量(件)',
    xlsxFmt: {
      t: 'n'
    }
  },
  'signedMoney': {
    title: '已签约总金额(万元)',
    xlsxFmt: {
      t: 'n'
    }
  },
  'noReportClients': {
    title: '未提报客户数量(家)',
    xlsxFmt: {
      t: 'n'
    }
  },
  'noReportQty': {
    title: '未提报总量(件)',
    xlsxFmt: {
      t: 'n'
    }
  },
  'noReportMoney': {
    title: '未提报总金额(万元)',
    xlsxFmt: {
      t: 'n'
    }
  },
  'centerAuditClients': {
    title: '大区审批中的客户数量(家)',
    xlsxFmt: {
      t: 'n'
    }
  },
  'centerAuditQty': {
    title: '大区审批中的总量(件)',
    xlsxFmt: {
      t: 'n'
    }
  },
  'centerAuditMoney': {
    title: '大区审批中的总金额(万)',
    xlsxFmt: {
      t: 'n'
    }
  },
  'oaAuditClients': {
    title: 'OA审批中的客户数量(家)',
    xlsxFmt: {
      t: 'n'
    }
  },
  'oaAuditQty': {
    title: 'OA审批中的总量(件)',
    xlsxFmt: {
      t: 'n'
    }
  },
  'oaAuditMoney': {
    title: 'OA审批中的总金额(万)',
    xlsxFmt: {
      t: 'n'
    }
  },
  'planAuditClients': {
    title: '计划部确认中的客户数量(家)',
    xlsxFmt: {
      t: 'n'
    }
  },
  'planAuditQty': {
    title: '计划部确认中的总量(件)',
    xlsxFmt: {
      t: 'n'
    }
  },
  'planAuditMoney': {
    title: '计划部确认中的总金额(万)',
    xlsxFmt: {
      t: 'n'
    }
  },
  'signFinishCltRatio': {
    title: '签约完成客户比率(%)',
    xlsxFmt: {
      t: 'n'
    }
  },
  'signFinishQtyRatio': {
    title: '签约量完成比率(%)',
    xlsxFmt: {
      t: 'n'
    }
  },
}



// WEBPACK FOOTER //
// ./src/views/qy-manage/config/signingCompleted.js